<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div v-show="CheckRoute()" class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit">
            <div
              class="row"
              v-if="this.$root.canShow(['ADMIN_5S', 'MANAGER_5S'])"
            >
              <div class="col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    v-model="melKeyword"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจาก ชื่อหมวดหมู่"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'melInActiveStatus'"
                    :name="'melInActiveStatus'"
                    :select2-options="melInActiveStatusOptions"
                    v-model="melInActiveStatus"
                    ref="melInActiveStatusSelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    v-model="melKeyword"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจาก ชื่อหมวดหมู่"
                  />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <router-link
                  to="E-Learning/AddFolder"
                  tag="button"
                  title="เพิ่ม"
                  class="btn btn-outline-brand"
                  v-if="this.$root.canShow(['ADMIN_5S', 'MANAGER_5S'])"
                >
                  <i class="fa fa-folder-plus"></i> เพิ่มหมวดหมู่
                </router-link>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div
            class="row"
            v-if="this.$root.canShow(['COMPANY_PROFILE_TYPE_AGENT'])"
          >
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="folderTable"
              >
                <thead>
                  <tr>
                    <th class="all">หมวดหมู่</th>
                    <th class="all">ผู้บันทึก</th>
                    <th class="all">วันที่บันทึกล่าสุด</th>
                    <th class="all">สถานะ</th>
                    <th class="all">การจัดการ</th>
                  </tr>
                </thead>
                <!-- <tbody v-show="false" id="text1"></tbody> -->
              </table>
            </div>
          </div>
          <div
            class="row"
            v-if="!this.$root.canShow(['COMPANY_PROFILE_TYPE_AGENT'])"
          >
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="folderTable"
              >
                <thead>
                  <tr>
                    <th class="all">หมวดหมู่</th>
                    <th class="all">ผู้บันทึก</th>
                    <th class="all">วันที่บันทึกล่าสุด</th>
                    <th class="all">การจัดการ</th>
                  </tr>
                </thead>
                <!-- <tbody v-show="false" id="text1"></tbody> -->
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton"class="btn btn-sm btn-success">
      <i class="fas fa-play"></i>เปิดใช้งาน
    </a>
    <a href="#" onclick="return false;" v-else class="btn btn-sm btn-success">
      <i class="fas fa-play"></i>เปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/Folder/" + this.data.folderElearningId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-danger">
      <i class="fas fa-pause"></i>ปิดใช้งาน
    </a>
    <a href="#" onclick="return false;" v-else class="btn btn-sm btn-danger">
      <i class="fas fa-pause"></i>ปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/Folder/" + this.data.folderElearningId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let Action = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="edit" v-if="data.showEditButton" title="เปลี่ยนชื่อหมวดหมู่" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="text-info la la-pencil"></i>
    </a>
    <a :href="'/5S/E-Learning/Detials/' + data.folderElearningId" @click.prevent="Details" v-if="data.showOpenFolderButton" title="รายละเอียด" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="text-info far fa-folder-open"></i>
    </a>
    <a href="#" @click.prevent="Delete" v-if="data.showDeletesButton" title="ลบหมวดหมู่" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="text-danger fas fa-trash-alt"></i>
    </a>
  </div>`,
  data: function() {
    console.log(this);
    return {
      //Id: data.,
    };
  },
  methods: {
    edit: function() {
      let self = this;
      // router.push({
      //   path: `/5S/E-Learning/RenameFolder/${this.data.folderElearningId}`
      // });
      Swal.fire({
        title: "คำสั่งเปลี่ยนชื่อหมวดหมู่",
        type: "info",
        html: "กรุณาระบุชื่อหมวดหมู่ <strong>",
        input: "text",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          if (value) {
            return value;
          } else {
            Swal.showValidationMessage("กรุณาระบุชื่อหมวดหมู่");
          }
        },
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังดำเนินการ กรุณารอสักครู่...",
          });

          axios
            .put("/Api/Folder", {
              FolderElearningId: this.data.folderElearningId,
              FolderName: result.value,
            })
            .then(function(response) {
              console.log(response.data.status);
              if (response.data.status == true) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
    Delete: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูลหมวดหมู่",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งลบข้อมูลหมวดหมู่ <strong>" +
          "</strong> หลังจากลบแล้วจะส่งผลให้ข้อมูลหมวดหมู่ไม่ถูกใช้งาน",
        inputPlaceholder: "ต้องการลบข้อมูลหมวดหมู่",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/Folder/" + this.data.folderElearningId + "/Delete")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
    Details: function() {
      router.push({
        path: `/5S/E-Learning/Detials/${this.data.folderElearningId}`,
      });
    },
  },
});

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;

    return {
      melKeyword: null,
      melInActiveStatus: null,
      //config
      melInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null },
        ],
      },
    };
  },
  methods: {
    formReset: function(e) {
      this.melKeyword = "";
      //default Active Data
      this.melInActiveStatus = false;
      $("#melInActiveStatus")
        .val(this.melInActiveStatus + "")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#folderTable").DataTable();
      table.search(this.id | this.name);
      //table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#folderTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    CheckRoute() {
      var url = this.$route.path;
      if (url == "/5S/E-Learning/Detials/" + this.$root.$route.params.id)
        return false;
      else if (
        url ==
        "/5S/E-Learning/Detials/" +
          this.$root.$route.params.id +
          "/AddSubFolder"
      )
        return false;
      // else if(url == '/Borrow/Approve/'+this.$root.$route.params.id) return false;
      // else if(url == '/Borrow/OpenJopReturn/'+this.$root.$route.params.id) return false;
      // else if(url == '/Borrow/Add') return false;
      else return true;
    },
  },
  async mounted() {
    let self = this;

    //default Active Data
    self.melInActiveStatus = false;
    $("#melInActiveStatus")
      .val(self.melInActiveStatus + "")
      .trigger("change");

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#folderTable");

    // begin first table
    if (!this.$root.canShow(["COMPANY_PROFILE_TYPE_AGENT"])) {
      table
        .DataTable({
          responsive: true,
          processing: true,
          serverSide: true,
          searchDelay: 500,
          ajax: {
            url: "/Api/Folder/Search",
            type: "post",
            dataType: "json",
            contentType: "application/json",
            beforeSend: function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            },
            data: function(d) {
              //console.log(d);
              return JSON.stringify(
                $.extend(d, {
                  SearchKeyword: self.melKeyword,
                  SearchInActiveStatus: self.melInActiveStatus,
                })
              );
            },
          },
          // DOM Layout settings
          dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
          <'row'<'col-sm-12'tr>>
          <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

          lengthMenu: [30, 50, 100],

          pageLength: 30,

          language: {
            lengthMenu: "Display _MENU_",
          },

          // Order settings
          order: [[2, "desc"]],
          columns: [
            {
              data: "folderName",
              render: function(data, type, full, meta) {
                return (
                  '<a href="/5S/E-Learning/Detials/' +
                  full.folderElearningId +
                  '" title="รายละเอียด">' +
                  data +
                  "</i></a>"
                );
              },
            },
            { data: "createdBy", className: "text-center" },
            {
              data: "createdDate",
              className: "text-center",
              render: function(data, type, full, meta) {
                return full.createdDateFormat;
              },
            },
            {
              data: "folderElearningId",
              className: "text-center",
              orderable: false,
              render: function(data, type, full, meta) {
                return '<div class="actions"></div>';
              },
            },
          ],
        })
        .on("error.dt", function ( e, settings, techNote, message ) {
          DatatableWarning.alert(techNote);
        })
        .on("draw.dt", function() {
          $(".actionsStatus").each(function(i, el) {
            var $dt = table.DataTable();
            var $tr = $(el)
              .parents("tr")
              .first();
            var data = $dt.row($tr).data();
            if (data) {
              data.showEditStatusButton = self.$root.canShow([
                "ADMIN_5S",
                "MANAGER_5S",
              ]);
              data.showUnEditStatusButton = self.$root.canShow([
                "AGENT_E-Learning",
              ]);
              if (data.inActiveStatus == 0)
                new StatusActionsTrue({ data: { data }, parent: self }).$mount(
                  el
                );
              else if (data.inActiveStatus == 1)
                new StatusActionsFalse({ data: { data }, parent: self }).$mount(
                  el
                );
            }
          });
          $(".actions").each(function(i, el) {
            var $dt = table.DataTable();
            var $tr = $(el)
              .parents("tr")
              .first();
            var data = $dt.row($tr).data();
            if (data) {
              data.showEditButton = self.$root.canShow(["ADMIN_5S"]);
              data.showOpenFolderButton = self.$root.canShow([
                "ADMIN_5S",
                "AGENT_E-Learning",
                "ADVISOR_5S",
                "TEAM_5S",
              ]);
              data.showDeletesButton = self.$root.canShow(["ADMIN_5S"]);
              new Action({ data: { data }, parent: self }).$mount(el);
            }
          });
        });
    } else {
      table
        .DataTable({
          responsive: true,
          processing: true,
          serverSide: true,
          searchDelay: 500,
          ajax: {
            url: "/Api/Folder/Search",
            type: "post",
            dataType: "json",
            contentType: "application/json",
            beforeSend: function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            },
            data: function(d) {
              //console.log(d);
              return JSON.stringify(
                $.extend(d, {
                  SearchKeyword: self.melKeyword,
                  SearchInActiveStatus: self.melInActiveStatus,
                })
              );
            },
          },
          // DOM Layout settings
          dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
          <'row'<'col-sm-12'tr>>
          <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

          lengthMenu: [30, 50, 100],

          pageLength: 30,

          language: {
            lengthMenu: "Display _MENU_",
          },

          // Order settings
          order: [[2, "desc"]],
          columns: [
            {
              data: "folderName",
              render: function(data, type, full, meta) {
                return (
                  '<a href="/5S/E-Learning/Detials/' +
                  full.folderElearningId +
                  '" title="รายละเอียด">' +
                  data +
                  "</i></a>"
                );
              },
            },
            { data: "createdBy", className: "text-center" },
            {
              data: "createdDate",
              className: "text-center",
              render: function(data, type, full, meta) {
                return full.createdDateFormat;
              },
            },
            {
              data: "inActiveStatus",
              className: "text-center",
              width: "10%",
              orderable: false,
              render: function(data, type, full, meta) {
                return '<div class="actionsStatus"></div>';
              },
            },
            {
              data: "folderElearningId",
              className: "text-center",
              orderable: false,
              render: function(data, type, full, meta) {
                return '<div class="actions"></div>';
              },
            },
          ],
        })
        .on("error.dt", function ( e, settings, techNote, message ) {
          DatatableWarning.alert(techNote);
        })
        .on("draw.dt", function() {
          $(".actionsStatus").each(function(i, el) {
            var $dt = table.DataTable();
            var $tr = $(el)
              .parents("tr")
              .first();
            var data = $dt.row($tr).data();
            if (data) {
              data.showEditStatusButton = self.$root.canShow([
                "ADMIN_5S",
                "MANAGER_5S",
              ]);
              data.showUnEditStatusButton = self.$root.canShow([
                "AGENT_E-Learning",
              ]);
              if (data.inActiveStatus == 0)
                new StatusActionsTrue({ data: { data }, parent: self }).$mount(
                  el
                );
              else if (data.inActiveStatus == 1)
                new StatusActionsFalse({ data: { data }, parent: self }).$mount(
                  el
                );
            }
          });
          $(".actions").each(function(i, el) {
            var $dt = table.DataTable();
            var $tr = $(el)
              .parents("tr")
              .first();
            var data = $dt.row($tr).data();
            if (data) {
              data.showEditButton = self.$root.canShow([
                "ADMIN_5S",
                "MANAGER_5S",
              ]);
              data.showOpenFolderButton = self.$root.canShow([
                "ADMIN_5S",
                "MANAGER_5S",
                "AGENT_E-Learning",
              ]);
              data.showDeletesButton = self.$root.canShow([
                "ADMIN_5S",
                "MANAGER_5S",
              ]);
              new Action({ data: { data }, parent: self }).$mount(el);
            }
          });
        });
    }
    //table.trigger("draw.dt"); //call ajax delete this row
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/5S/ManageELearning.vue